import { useHistory } from 'react-router-dom';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// ----------------------------------------------------------------------

export interface ErrorViewProps {
  code?: string;
  title: string;
  description: string;
  action?: React.ReactNode;
}

export function ErrorView({ code, title, description, action }: ErrorViewProps): JSX.Element {
  const history = useHistory();

  return (
    <Stack
      alignItems="center"
      flexGrow={1}
      justifyContent="center"
      spacing={2}
      sx={{
        textAlign: 'center',
        px: { xs: 3, md: 5 },
        py: { xs: 6, md: 10 },
        minHeight: '60vh',
        width: '100%',
      }}
    >
      {code && (
        <Typography
          component="span"
          sx={{
            fontWeight: 800,
            lineHeight: 1,
            color: 'text.disabled',
            fontSize: { xs: '5rem', md: '8rem' },
          }}
        >
          {code}
        </Typography>
      )}

      <Typography sx={{ color: 'text.primary' }} variant="h4">
        {title}
      </Typography>

      <Typography sx={{ color: 'text.secondary', maxWidth: 480 }} variant="body1">
        {description}
      </Typography>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ mt: 2 }}>
        {action ?? (
          <Button size="large" variant="contained" onClick={() => history.push('/')}>
            Go to home
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
